import { ListItem, ListItemIcon, ListItemText, ListSubheader, Typography } from "@material-ui/core";
import { ImportExport } from "@material-ui/icons";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { Collections } from "Collections";
import { useAppUser } from "components/AppUserProvider";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { AppRoles } from "models/AppRoles";
import { noPriceFieldNameText } from "models/PriceField";
import { PriceFieldCategories } from "models/PriceFieldCategories";
import { PriceFieldTemplate } from "models/PriceFieldTemplate";
import { Paths } from "Paths";
import { formatMoney } from "screens/Offer/CreateOffer/SummaryTable";

import { ListScreen } from "../ListScreen";

const getName = (priceFieldTemplate: PriceFieldTemplate) => noPriceFieldNameText(priceFieldTemplate.template.priceField.name?.text)

export function PriceFieldTemplatesScreen({ suggestions }: { suggestions?: boolean }) {
    const [appUser, loadingAppUser] = useAppUser()

    const isAdmin = !!appUser?.data.appRoles.map[AppRoles.FlatEnum.ADMIN]
    const canCreate = suggestions || isAdmin
    const canDelete = isAdmin

    return (
        <ListScreen<PriceFieldTemplate>
            standardBackButton
            title={suggestions ? 'Forslag til Maler' : "Maler"}
            canCreate={canCreate}
            canDelete={canDelete}
            collectionName={suggestions ? Collections.PRICE_FIELD_TEMPLATE_SUGGESTIONS : Collections.PRICE_FIELD_TEMPLATES}
            loadingQueryData={loadingAppUser}
            persist
            getName={getName}
            noEntriesText={suggestions ? 'Fant ingen nye forslag' : "Det er ingen maler i systemet enda"}
            createNewText={suggestions ? "Trykk her for å lage ett nytt forslag" : "Trykk her for å lage en ny mal"}
            fieldName={suggestions ? "priceFieldTemplateSugegstion" : "priceFieldTemplate"}
            path={suggestions ? Paths.PRICE_FIELD_TEMPLATE_SUGGESTIONS : Paths.PRICE_FIELD_TEMPLATES}
            createPath={suggestions ? Paths.CREATE_PRICE_FIELD_TEMPLATE_SUGGESTION : Paths.CREATE_PRICE_FIELD_TEMPLATE}
            dense
            getSecondaryText={({ template: { priceField } }) => (!Object.values(priceField.categories.map).length ? (
                <Typography variant="subtitle2" color="secondary">Har ingen kategorier</Typography>
            ) : formatMoney(priceField.price) + '  ' + PriceFieldCategories.FlatList.filter(category => !!priceField.categories.map[category.id]).map(category => category.name).join(', '))}
            deleteProps={{
                deleteEvent: suggestions ? AnalyticsEvent.REMOVED_PRICE_FIELD_TEMPLATE_SUGGESTION : AnalyticsEvent.REMOVED_PRICE_FIELD_TEMPLATE,
                deleteErrorEvent: suggestions ? AnalyticsEvent.DELETE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR : AnalyticsEvent.DELETE_PRICE_FIELD_TEMPLATE_ERROR,
                deleteContextEvent: suggestions ? AnalyticsEvent.REMOVED_PRICE_FIELD_TEMPLATE_SUGGESTION : AnalyticsEvent.REMOVED_PRICE_FIELD_TEMPLATE,
            }}
            copyProps={{
                copyEvent: suggestions ? AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE_SUGGESTION : AnalyticsEvent.CREATED_PRICE_FIELD_TEMPLATE,
                copyErrorEvent: suggestions ? AnalyticsEvent.CREATE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR : AnalyticsEvent.CREATE_PRICE_FIELD_TEMPLATE_ERROR,
                copyContextEvent: suggestions ? AnalyticsEvent.COPIED_PRICE_FIELD_TEMPLATE_SUGGESTION : AnalyticsEvent.COPIED_PRICE_FIELD_TEMPLATE,
            }}
            getErrorEvent={suggestions ? AnalyticsEvent.GET_PRICE_FIELD_TEMPLATE_SUGGESTIONS_ERROR : AnalyticsEvent.GET_PRICE_FIELD_TEMPLATES_ERROR}
            topItems={
                <>
                    <ListItem
                        component={RouterLink}
                        to={Paths.IMPORT_PRICE_FIELD_TEMPLATES}
                    >
                        <ListItemIcon>
                            <ImportExport />
                        </ListItemIcon>
                        <ListItemText
                            primary="Importer maler"
                            secondary="Trykk her for å se maler for din bransje"
                        />
                    </ListItem>
                    <ListSubheader>Alle Bransjer</ListSubheader>
                </>
            }
        />
    )
}
